import request from '@/utils/request/next-request';

/**
 * 使用nextRequest的请求
 */

// 搜索文档和产品
export function searchDocs(key: string) {
  return request({
    url: `${process.env.NEXT_PUBLIC_API_BASE_URL}/docs-search-by-key`,
    method: 'get',
    data: { key },
  });
}

// 根据productId/productCode获取已上线文档
export function getDocByProductId(params) {
  return request({
    url: `${process.env.NEXT_PUBLIC_API_BASE_URL}/docs`,
    method: 'get',
    data: params,
  });
}

// 获取热门文档
export function getTopDocs(data?: any) {
  return request({
    url: `${process.env.NEXT_PUBLIC_API_BASE_URL}/get-top-docs`,
    method: 'get',
    data: data,
  });
}
